// spawning.js - Creating platforms, enemies, coins, and boosts
//
// Every function takes an `rng` ([0,1) generator) so spawns are driven by the
// seeded gameplay RNG (see rng.js). Defaults to Math.random for safety.

export const createPlatform = (y, canvasWidth, forceSafe = false, currentHeight = 0, rng = Math.random) => {
  const rand = rng();
  let type = 'static';

  if (!forceSafe) {
    if (rand > 0.85) type = 'moving';
    else if (rand > 0.75) type = 'breakable';
    else if (rand > 0.65) type = 'fragile';
  }

  const hasSpring = false;  // Will be set in App.js with better spacing

  // Progressive platform size reduction
  let width = 68;
  if (currentHeight > 500) {
    // After 500m, 30% chance of smaller platform
    if (rng() > 0.7) {
      width = 48; // 30% smaller
    }
  }
  if (currentHeight > 1000) {
    // After 1000m, even more chance of smaller platforms
    if (rng() > 0.5) {
      width = 48;
    }
    if (rng() > 0.85) {
      width = 38; // Very small platforms
    }
  }

// Adjust height and width based on platform type
let height = 20;
if (type === 'fragile') {
  height = 15; // Thinner
  width = width * 0.9; // 10% narrower (optional)
} else if (type === 'moving') {
  height = 28; // Thicker
  width = width * 1.2; // 10% wider (optional)
} else if (type === 'breakable') {
  height = 22; 
  width = width * 0.9; 
}
// static/normal platforms keep default width and height = 20
  return {
    x: rng() * (canvasWidth - width),
    y: y,
    w: width,
    h: height,
    type: type,
    direction: rng() > 0.5 ? 1 : -1,
    broken: false,
    hasSpring: hasSpring,
    springCompression: 0,  // 0 = normal, 1 = compressed
    maxJumpHeight: 75
  };
};

export const createCoin = (y, canvasWidth, rng = Math.random) => {
  return {
    x: rng() * (canvasWidth - 30) + 15,
    y: y - 30,
    r: 17,
    collected: false,
    angle: 0
  };
};

export const createBoost = (y, canvasWidth, rng = Math.random) => {
  const rand = rng();
  let type;

if (rand > 0.80) type = 'rocket';
else if (rand > 0.60) type = 'magnet';       // NEW!
else if (rand > 0.45) type = 'doublePoints';
else if (rand > 0.30) type = 'shield';
else if (rand > 0.15) type = 'shooter';
else type = 'slowmo';


  return {
    x: rng() * (canvasWidth - 40) + 20,
    y: y,
    w: 30,
    h: 30,
    type: type,
    collected: false
  };
};

export const createEnemy = (y, canvasWidth, rng = Math.random) => {
  const rand = rng();
  let type = 'horizontal';
  let health = 1;
  let maxHealth = 1;
  let size = 55;
  
  if (rand > 0.85) {
    
    health = 2;
    maxHealth = 2;
    size = 55;
    type = 'horizontal';
  
  } else if (rand > 0.50) {
    
    health = 3;
    maxHealth = 3;
    size = 60;
    type = 'stationary';
   
  } else {
    // Normal 1-hit enemy (moving) (70% chance)
    health = 1;
    maxHealth = 1;
    size = 50;
    type = 'horizontal';
  }
  
  const initialDirection = rng() > 0.5 ? 1 : -1;
const enemyX = rng() * (canvasWidth - size - 20) + 10;

// Stationary bears face toward center of screen
const faceCenter = enemyX < canvasWidth / 2; // If on left side, face right (toward center)

return {
  x: enemyX,
  y: y,
  w: size,
  h: size,
  type: type,
  direction: initialDirection,
  speed: 1.0,
  health: health,
  maxHealth: maxHealth,
  floatOffset: 0,
  baseY: y,
  facingRight: type === 'stationary' ? faceCenter : (initialDirection === 1)
};
};